import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Icon,
  Pane,
  Paneset,
  Tooltip,
} from '@folio/stripes-components';
import { FieldArray } from 'react-final-form-arrays';
import { FormattedMessage } from 'react-intl';
import { FormSpy } from 'react-final-form';
import FormPreView from '../../FormPreView';
import SectionsArray from './SectionsArray';
import AddNewSectionForm from './AddNewSectionForm';

const propTypes = {
  paneTitle: PropTypes.node,
  appIcon: PropTypes.node,
  paneId: PropTypes.string,
  fieldArrayName: PropTypes.string,
  // initialValues: PropTypes.arrayOf(PropTypes.object),
};

function SectionsBuilder({
  paneTitle,
  paneId,
  appIcon,
  fieldArrayName,
  // initialValues,
}) {
  let arrayFields;
  const [showPreviewPane, setShowPreviewPane] = useState(true);
  const [openSectionBuilder, setOpenSectionBuilder] = useState(false);
  const [actionType, setActionType] = useState('create');
  const [sectionInitValues, setSectionInitValues] = useState({
    sectionLabel: [
      {
        locale: 'ar',
        value: '',
      },
      {
        locale: 'en-US',
        value: '',
      },
    ],
    sectionFields: [],
  });

  const PaneFirstMenu = (
    <Button
      onClick={() => {
        setOpenSectionBuilder(true);
        setActionType('create');
        setSectionInitValues({
          sectionLabel: [
            {
              locale: 'ar',
              value: '',
            },
            {
              locale: 'en-US',
              value: '',
            },
          ],
          sectionFields: [],
        });
      }}
      onMouseDown={(e) => e.preventDefault()}
      marginBottom0
      buttonStyle="default"
    >
      <Icon icon="plus-sign">
        <FormattedMessage
          id="ui-plugin-inventory-templates.templateFields.builder.openSectionsBuilder"
          defaultMessage="New section"
        />
      </Icon>
    </Button>
  );

  const PaneLastMenu = (
    <>
      {/* <Tooltip
        id="fields-builder-import-from-default-tooltip"
        text={
          <FormattedMessage
            id="ui-plugin-inventory-templates.sectionsBuilder.importFromDefault.tooltip.msg"
            defaultMessage="Import sections and fields from default scheme"
          />
        }
      >
        {({ ref, ariaIds }) => (
          <Button
            onClick={() => {
              initialValues.map((field) => arrayFields.push(field));
            }}
            onMouseDown={(e) => e.preventDefault()}
            marginBottom0
            aria-labelledby={ariaIds.text}
            ref={ref}
            buttonStyle="default"
          >
            <Icon icon="lightning">
              <FormattedMessage
                id="ui-plugin-inventory-templates.sectionsBuilder.buttons.importFromDefault"
                defaultMessage="Import"
              />
            </Icon>
          </Button>
        )}
      </Tooltip> */}
      {!showPreviewPane ? (
        <Tooltip
          id="fields-builder-hide-pane-tooltip"
          text={
            <FormattedMessage
              id="ui-plugin-inventory-templates.tooltip.showformPreviewPane.msg"
              defaultMessage="Show form preview pane"
            />
          }
        >
          {({ ref, ariaIds }) => (
            <Button
              buttonStyle="dropdownItem"
              id="fields-builder-hide-pane-btn"
              marginBottom0
              onClick={() => setShowPreviewPane(true)}
              aria-labelledby={ariaIds.text}
              ref={ref}
            >
              <Icon icon="eye-open" size="large" />
            </Button>
          )}
        </Tooltip>
      ) : (
        <div />
      )}
    </>
  );

  return (
    <Paneset>
      <Pane
        id={`${paneId}-builder-pane`}
        appIcon={appIcon || <div />}
        paneTitle={paneTitle}
        fluidContentWidth
        centeredContent
        padContent
        firstMenu={PaneFirstMenu}
        lastMenu={PaneLastMenu}
      >
        <FieldArray
          id={`template-${paneId}-sections-builder`}
          name={`templateFields.${fieldArrayName}`}
          render={({ fields }) => {
            arrayFields = fields;
            return (
              <SectionsArray
                fields={fields}
                openSectionBuilder={openSectionBuilder}
                setActionType={setActionType}
                setOpenSectionBuilder={setOpenSectionBuilder}
                setSectionInitValues={setSectionInitValues}
                paneId={paneId}
              />
            );
          }}
        />
        <AddNewSectionForm
          open={openSectionBuilder}
          onClose={() => {
            setOpenSectionBuilder(false);
            setActionType('create');
          }}
          arrayFields={arrayFields}
          fieldArrayName={fieldArrayName}
          fieldName={arrayFields?.name}
          actionType={actionType}
          initialValues={sectionInitValues}
        />
      </Pane>
      {showPreviewPane && (
        <Pane
          id={`${paneId}-preview-pane`}
          defaultWidth="50%"
          height="100%"
          appIcon={appIcon || <div />}
          paneTitle={
            <FormattedMessage
              id="ui-plugin-inventory-templates.templateFields.formPreview.paneTitle"
              defaultMessage="Form Preview"
            />
          }
          fluidContentWidth
          centeredContent
          padContent
          lastMenu={
            <Tooltip
              id="form-preview-hide-pane-tooltip"
              text={
                <FormattedMessage
                  id="ui-plugin-inventory-templates.tooltip.hideFormPreviewPane.msg"
                  defaultMessage="Hide form preview pane"
                />
              }
            >
              {({ ref, ariaIds }) => (
                <Button
                  buttonStyle="dropdownItem"
                  id="form-preview-hide-pane-btn"
                  marginBottom0
                  onClick={() => setShowPreviewPane(!showPreviewPane)}
                  aria-labelledby={ariaIds.text}
                  ref={ref}
                >
                  <Icon icon="eye-closed" size="large" />
                </Button>
              )}
            </Tooltip>
          }
        >
          <FormSpy subscription={{ values: true }}>
            {({ values }) => (
              <FormPreView
                formValues={
                  values?.templateFields
                    ? values?.templateFields[fieldArrayName]
                    : []
                }
                fieldArrayName={fieldArrayName}
              />
            )}
          </FormSpy>
        </Pane>
      )}
    </Paneset>
  );
}

SectionsBuilder.propTypes = propTypes;

export default SectionsBuilder;
